// 3rd
import Swiper, { EffectFade, Navigation, Thumbs } from 'swiper';

const mediaSlider = document.querySelector('.media-slider');
const mediaSliderActiveMedia = document.querySelector(
  '.media-slider__active-media',
);
const mediaSliderThumbs =
  mediaSlider && mediaSlider.querySelector('.media-slider__thumbs');
const mediaSliderThumbsSlides =
  mediaSliderThumbs &&
  [...mediaSliderThumbs.querySelectorAll('.swiper-slide')].length;

const initGallery = () => {
  const galleryThumbs = new Swiper(mediaSliderThumbs, {
    breakpoints: {
      701: {
        slidesPerView: 5,
        spaceBetween: 8,
      },
      1181: {
        slidesPerView: 5,
        spaceBetween: 12,
      },
      1441: {
        slidesPerView: 6,
        spaceBetween: 16,
      },
    },
    on: {
      init: (swiper) => {
        if (mediaSliderThumbsSlides > swiper.params.slidesPerView) {
          mediaSliderThumbs.classList.add('scroll--start');
        } else {
          mediaSliderThumbs.classList.remove('scroll--start', 'scroll--end');
        }
      },
      breakpoint: (swiper) => {
        if (mediaSliderThumbsSlides > swiper.params.slidesPerView) {
          mediaSliderThumbs.classList.add('scroll--start');
        } else {
          mediaSliderThumbs.classList.remove('scroll--start', 'scroll--end');
        }
      },
      touchMove: (swiper) => {
        if (mediaSliderThumbsSlides > swiper.params.slidesPerView) {
          if (!swiper.isBeginning && !swiper.isEnd) {
            mediaSliderThumbs.classList.add('scroll--start', 'scroll--end');
          }

          if (swiper.isBeginning) {
            mediaSliderThumbs.classList.add('scroll--start');
            mediaSliderThumbs.classList.remove('scroll--end');
          }

          if (swiper.isEnd) {
            mediaSliderThumbs.classList.add('scroll--end');
            mediaSliderThumbs.classList.remove('scroll--start');
          }
        }
      },
    },
    slidesPerView: 3,
    spaceBetween: 5,
    speed: 400,
    watchOverflow: true,
  });

  // eslint-disable-next-line no-new
  new Swiper(mediaSliderActiveMedia, {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    modules: [EffectFade, Navigation, Thumbs],
    navigation: {
      prevEl: '.navigation-button--prev',
      nextEl: '.navigation-button--next',
    },
    on: {
      activeIndexChange(swiper) {
        // stop yt video playing if slides change
        const videos = swiper.el.querySelectorAll('iframe');
        videos.forEach((v) => {
          const videoSrc = v.getAttribute('src');
          v.setAttribute('src', videoSrc);
        });
      },
    },
    speed: 400,
    thumbs: {
      swiper: mediaSliderThumbsSlides > 1 && galleryThumbs,
      multipleActiveThumbs: false,
    },
    watchOverflow: true,
  });
};

(() => {
  if (mediaSlider) initGallery();
})();
